/* esm.sh - applesauce-core@5.2.0/event-factory */
export * from "/*applesauce-core@5.2.0/esnext/event-factory.mjs";
